import React, { useState } from 'react';
import MathJax from "../react-mathjax-preview";
import { Checkbox, TextField } from 'react-md';
import MathParserUtil from '../../lib/math-parser';

const TextBox = ({answer_formula}) => {
    const {formula,formulaMap,formulaPrefix,formulaSuffix} = answer_formula;
    
    const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(formula);
    if(formulaTextArray && formulaTextArray.length > 0 && formulaMap ){
        return <React.Fragment>
                    {
                        formulaTextArray.map((ansSegment,index) =>{
                            
                            if(formulaMap.get(`{{${ansSegment}}}`)){
                                return <div style={{marginLeft:"-12px"}}> 

                                                Fill in the input box:
                                               <div style={{display:"flex",marginTop:"10px"}}>
                                                    <div style={{fontSize:"14px",marginRight:"2px",marginTop:"10px",fontWeight:"400"}}>
                                                        {formulaPrefix != "" ? <MathJax math={formulaPrefix} /> : ''}                
                                                    </div> 
                                                    <TextField  id={`rp-preview-ans-text-box-${index}`} className="rp-ft-input rp-fr-text" 
                                                                style={{display:"inline-block",height:"30px"}}
                                                                                resize={{ min: 30, max :500}}
                                                                            />  
                                                
                                                <div style={{fontSize:"14px",marginLeft:"2px",marginTop:"7px",fontWeight:"400"}}>
                                                    {formulaSuffix != "" ? <MathJax math={formulaSuffix} /> : ''}                
                                                    </div> 
                                        </div> 
                                </div> 
                            }else{
                                if(ansSegment && ansSegment.length > 0)
                                    return React.createElement(MathJax,{className: "rp-ft-mathjax","math":ansSegment});
                                else
                                    return ""
                            } 
                        })
                    }
                </React.Fragment>
        
    }
    else{
        return null;
    }
}

const SciNotation = ({answer_formula})=>{
    const [scifiText,setScifiText] = useState("")
    const [scifiTextExp,setScifiTextExp] = useState("")
    const {formula,formulaMap,formulaPrefix,formulaSuffix} = answer_formula;

    const resizeTextBoxWidthPower = (textBoxID,value) => {
        const newWidth = (document.getElementById(textBoxID).value.length+1)*6.5;
        if(newWidth < 10){
            document.getElementById(textBoxID).style.width = '50px';
        }else{
            document.getElementById(textBoxID).style.width = `${newWidth*2}px`;   
        } 
        setScifiTextExp(value)
    }

    const resizeTextBoxWidth = (textBoxID,value) => {
        const newWidth = (document.getElementById(textBoxID).value.length+1)*6;
        if(newWidth < 10){
            document.getElementById(textBoxID).style.width = '20px';
        }else{
            document.getElementById(textBoxID).style.width = `${newWidth*2}px`;   
        } 
        setScifiText(value)
    }
    
    const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(formula);
    if(formulaTextArray && formulaTextArray.length > 0 && formulaMap ){
        return <div className="rp-text-box"> 
              
                 <div > 
                <div className={`scifi-container`}>
                    <div style={{fontSize:"14px",marginRight:"2px",marginTop:"12px",fontWeight:"500"}}>
                        {formulaPrefix != "" ? <MathJax  textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaPrefix} /> : ''}                
                    </div> 
                    <div  className="scifi-textbox">
                    {
                                formulaTextArray.map((ansSegment,index) =>{
                                    if(formulaMap.get(`{{${ansSegment}}}`)){
                                        return <React.Fragment>
                                                    
                                                    {
                                                        scifiText !== "" ?

                                                        <TextField  id={`rp-preview-ans-text-box-${index}`} 
                                                                    className="rp-scifi-textbox"
                                                                    style={{minWidth:'10px'}}
                                                                    onChange={(value) => {resizeTextBoxWidth(`rp-preview-ans-text-box-${index}`,value)}}
                                                                    value={scifiText?scifiText:""}
                                                       /> :
                                                       <TextField  id={`rp-preview-ans-text-box-${index}`} 
                                                       className="rp-scifi-textbox-temp"
                                                       style={{minWidth:'10px'}}
                                                       onChange={(value) => {resizeTextBoxWidth(`rp-preview-ans-text-box-${index}`,value)}}
                                                       value={scifiText?scifiText:""}
                                          /> 
                                                    }
                                                </React.Fragment>
                                    }else{
                                        if(ansSegment && ansSegment.length > 0)
                                            return <td style={{fontSize:'1em', paddingTop:'15px'}}>{React.createElement(MathJax,{className: "rp-ft-mathjax","math":ansSegment})}</td>
                                        else
                                            return <td></td>
                                    } 
                                })
                            }
                    </div>
                    <div  className="scifi-textbox-power">
                    x {" "} 10
                    </div>
                    <div  className="scifi-scifibox-exponent">
                    {                    
                                formulaTextArray.map((ansSegment,index) =>{
                                    if(formulaMap.get(`{{${ansSegment}}}`)){
                                        return  <React.Fragment>
                                                    { scifiTextExp !== "" ?
                                                        <TextField  id={`rp-preview-ans-text-box-${index}`} 
                                                        className="rp-scifi-textbox-exponent"
                                                        onChange={() => {resizeTextBoxWidthPower(`rp-preview-ans-text-box-${index}`)}}
                                                        style={{minWidth:'20px'}}
                                                        resize={{ min: 30, max :500}}
                                                        />
                                                     :
                                                            <TextField  id={`rp-preview-ans-text-box-${index}`} 
                                                                        className="rp-scifi-textbox-exponent-temp"
                                                                        onChange={() => {resizeTextBoxWidthPower(`rp-preview-ans-text-box-${index}`)}}
                                                                        style={{minWidth:'20px'}}
                                                                        resize={{ min: 30, max :500}}
                                                                 />
                                                    }
                                                </React.Fragment>
                                    }
                                })
                            }
                    </div>
                    <div style={{fontSize:"14px",marginLeft:"8px",marginTop:"15px",fontWeight:"500"}}>
                        {formulaSuffix != "" ? <MathJax textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaSuffix} /> : ''}                
                        </div> 
                </div>
        </div>
        </div>
    }else{
        return null;
    }
   
}

const Fraction = ({answer_formula})=>{
    const {formula,formulaMap,formulaPrefix,formulaSuffix} = answer_formula;
    const [signValues,setSignValues] = useState({});

    const onInputElementSignValueChange = (argValue,ansKey) => {
        let tempSignValues= {...signValues};
        tempSignValues[ansKey] = argValue;
        setSignValues(tempSignValues);
    }
    const resizeTextBoxWidthFraction = (textBoxID) => {
            const newWidth = (document.getElementById(textBoxID).value.length+1)*6.5;
            if(newWidth < 10){
                document.getElementById(textBoxID).style.width = '50px';
            }else{
                document.getElementById(textBoxID).style.width = `${newWidth*2}px`;   
            } 
    }
   
    const buildFractionTableData = (formulaTextArray,formulaMap) =>{
        let data = [];

        for(let index = 0; index < formulaTextArray.length ; index++){
            let ansSegment = formulaTextArray[index];
            
            let tempColumn = {};
            tempColumn['row0'] = <td key={`rp-sign-row0-${index}`}></td>;
            if(formulaMap.get(`{{${ansSegment}}}`)){
                tempColumn['row1'] = <td style={{lineHeight:'0',paddingTop:'38px'}} key={`rp-sign-row2-${index}`}>
                                        {signValues[ansSegment]?<span style={{fontSize:'20px',marginLeft:"3px"}}>&#8212;</span>:''}
                                    </td>;
            }else{
                tempColumn['row1'] = <td key={`rp-sign-row2-${index}`}></td>
            }
            tempColumn['row2'] = <td key={`rp-sign-row1-${index}`}></td>;
            tempColumn['row3'] = <td key={`rp-sign-row3-${index}`}></td>;  
            data.push(tempColumn);                   
            

            tempColumn = {};
        
            if(formulaMap.get(`{{${ansSegment}}}`)){
                tempColumn['row0'] =  <td key={`rp-textbox-value-row0-${index}`}>
                                                <Checkbox
                                                    id={`rp-sign-row0-${index}`}
                                                    name="Enable negative sign"
                                                    onChange={checked => onInputElementSignValueChange(checked,ansSegment)}
                                                    value={signValues[ansSegment]?signValues[ansSegment]:""}
                                                    className='rp-fraction-checkbox'
                                                    label = "Add a negative sign"
                                                />
                                                
                </td>;
                tempColumn['row1'] =  <td key={`rp-textbox-value-row1-${index}`}>
                                            <TextField  id={`rp-textbox-value-row1-${index}`} 
                                                className="rp-ft-input rp-fr-textbox-value rp-fraction-textfield rp-fr-num"
                                                style={{display:"inline-block",minWidth:"100px"}}
                                                size={3}
                                                fullWidth={false}
                                                onChange={() => {resizeTextBoxWidthFraction(`rp-textbox-value-row1-${index}`)}}
                                                />
                                        </td>;
                tempColumn['row2'] = <td key={`rp-textbox-value-row2-${index}`} style={{padding:'0px',display:'none'}}>
                                    </td>;
                tempColumn['row3'] =  <td  key={`rp-textbox-value-row3-${index}`} style={{position:"relative", top:"-3px"}}>
                                            <TextField  
                                                id={`rp-textbox-value-row3-${index}`} 
                                                className="rp-ft-input   rp-fraction-textfield  rp-fr-textbox-value rp-fr-dnm" 
                                                style={{display:"inline-block",minWidth:"100px"}}
                                                size={3}
                                                fullWidth={false}
                                                onChange={() => {resizeTextBoxWidthFraction(`rp-textbox-value-row3-${index}`)}}
                                                   
                                                />
                                        </td>;

            }else{
                tempColumn['row0'] = <td key={`rp-textbox-text-row0-${index}`}></td>;
                tempColumn['row1'] = <td key={`rp-textbox-text-row1-${index}`}></td>;
                tempColumn['row2'] = <td key={`rp-textbox-text-row2-${index}`}>{React.createElement(MathJax,{className: "rp-ft-mathjax","math":ansSegment})}</td>;
                tempColumn['row3'] = <td key={`rp-textbox-text-row3-${index}`}></td>; 
            }
            data.push(tempColumn);
        
        }

        return data;
    }

    const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(formula);
    const tableData = buildFractionTableData(formulaTextArray,formulaMap);
    

    
    
    if(formulaTextArray && formulaTextArray.length > 0 && formulaMap ){
        
        return <div> 
                    <div  
                        className="rp-text-box" style={{
                        position:"relative",
                        display:"flex",
                        alignItems:'center',
                    }}>
                                <div style={{fontSize:"14px",fontWeight:"500", marginBottom:'2.2rem',marginTop:'25px',whiteSpace:"nowrap"  }}>
                                                            {formulaPrefix != "" ? <MathJax textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaPrefix} /> : ''}                
                                </div> 
                                    <table style={{marginLeft:"-12px"}}>
                                    <tbody style={{textAlign:"center"}}>

                                        <tr>
                                        {
                                            tableData.map(columnData=>{
                                                return columnData.row1
                                            })
                                        }
                                        </tr>
                                    
                                        <tr>
                                        {
                                            tableData.map(columnData=>{
                                                return columnData.row3
                                            })
                                        }
                                        </tr>
                    
                                    </tbody>
                                    </table>
                                    <div style={{fontSize:"14px",fontWeight:"500",marginLeft:"-9px", marginBottom:"2.2rem",marginTop:'25px',whiteSpace:"nowrap"}}>
                                         {formulaSuffix != "" ? <MathJax textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaSuffix} /> : ''}                
                                    </div> 
                    </div>
                    <div style={{display:"flex",alignItems:"center",justifyContent:"start"}}>
                        <div style={{ visibility: "hidden",fontSize:"14px",fontWeight:"500", marginBottom:'2.2rem',marginTop:'25px',whiteSpace:"nowrap"  }}>
                                                    {formulaPrefix != "" ? <MathJax textID="formulaPrefixSuffix-style-prefix" className="formulaPrefixSuffix-style" math={formulaPrefix} /> : ''}                
                        </div> 
                        <table style={{marginLeft:"-20px"}}>
                                <tbody>
                              
                                <tr>
                                    {
                                            tableData.map(columnData=>{
                                                return columnData.row0
                                            })
                                        }
                                    </tr>
                
                                </tbody>
                        </table>
                    </div>
               
        </div>
    }else{
        return null;
    }
   
}


const RPPreview = ({answer_formula,answerFormat}) => {
    const props ={answer_formula};
    if(answerFormat === 1 || answerFormat === 5 || answerFormat === 6)
        return <TextBox {...props}></TextBox>
    else if(answerFormat === 2)
        return <SciNotation {...props}></SciNotation>
    else if (answerFormat === 4)
        return <TextBox {...props}></TextBox>
    else 
        return <Fraction {...props}></Fraction>
}

export default RPPreview;